import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../help/routing-help.mdx";

export function RoutingHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
